export default __webpack_public_path__ + "static/media/1926.3a6b707d.png";